import {
    Component, Directive, ChangeDetectionStrategy, HostBinding, ViewEncapsulation,
    Input, ContentChild, forwardRef, QueryList, OnInit, Output, EventEmitter,
} from '@angular/core';

@Component({
    selector: 'eui-page-header',
    templateUrl: './eui-page-header.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiPageHeaderComponent implements OnInit {

    @HostBinding('class')
    get cssClasses() {
        return [
            `eui-page-header`,
            this.isCollapsible ? 'eui-page-header--collapsible' : '',
            this.isCollapsed ? 'eui-page-header--collapsed' : '',
        ].join(' ').trim();
    }

    @Input() label;
    @Input() subLabel;
    @Input() isCollapsible = false;
    @Input() isCollapsed = false;
    @Input() collapsedLabel = '';   // Expand
    @Input() expandedLabel = '';    // Collapse

    @Output() collapse = new EventEmitter<boolean>();

    @ContentChild(forwardRef(() =>
        EuiPageHeaderActionItemsContentDirective),
    ) customPageHeaderActionItemsContent: QueryList<EuiPageHeaderActionItemsContentDirective>;

    @ContentChild(forwardRef(() =>
        EuiPageBodyContentDirective),
    ) customPageHeaderBodyContent: QueryList<EuiPageBodyContentDirective>;

    constructor(
    ) {
    }

    ngOnInit() {
    }

    public onToggle(collapseState: boolean) {
        this.isCollapsed = collapseState;
        this.collapse.emit(collapseState);
    }
}

/* tslint:disable */
@Directive({ selector: 'eui-page-header-action-items' })
export class EuiPageHeaderActionItemsContentDirective { }

@Directive({ selector: 'eui-page-header-body' })
export class EuiPageBodyContentDirective { }
/* tslint:enable */
